import React from 'react';
import { FadeIn, Section } from './Shared';
export const StorySection = () => {
  return <Section bg="cream" className="relative" data-id="element-305">
      <div className="max-w-2xl mx-auto" data-id="element-306">
        <FadeIn data-id="element-307">
          <div className="bg-white p-6 md:p-10 rounded-3xl shadow-sm border border-gray-100 relative" data-id="element-308">
            {/* Quote mark decoration */}
            <div className="absolute top-6 left-6 text-brand-teal/10 text-8xl font-heading leading-none pointer-events-none" data-id="element-309">
              "
            </div>

            <div className="relative z-10 space-y-4 text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-310">
              <p data-id="element-311">Yo también me despertaba cansada.</p>
              <p data-id="element-312">Me miraba al espejo y no reconocía mi cuerpo.</p>
              <p data-id="element-313">Probé dietas, ejercicio, suplementos…</p>
              <p className="font-medium" data-id="element-314">Nada funcionaba.</p>

              <div className="h-px w-16 bg-brand-teal/30 my-8" data-id="element-315"></div>

              <p data-id="element-316">Hasta que entendí algo clave:</p>
              <p className="text-2xl font-bold text-brand-charcoal font-heading" data-id="element-317">
                Mi hígado estaba colapsado.
              </p>

              <div className="bg-brand-teal/5 p-6 rounded-xl mt-8" data-id="element-318">
                <p className="font-medium text-brand-teal" data-id="element-319">
                  Cuando cambié eso…
                </p>
                <p className="text-2xl font-bold text-brand-charcoal mt-2" data-id="element-320">
                  Todo cambió.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};